module.exports = __webpack_public_path__ + "static/media/logo.1e46990f.svg";